import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { useMapStore } from '../../stores/map/useMapStore';

export default function MapReadyHandler() {

    const map = useMap();

    useEffect(() => {

        const { setMapReady } = useMapStore.getState();

        setMapReady(true);

        return () => {
            setMapReady(false);
        };

    }, [map]);

    return null;

}